module.exports = __webpack_public_path__ + "img/login-logo.e080df63.png";